import { render, staticRenderFns } from "./PasswordRequest.vue?vue&type=template&id=ad15f6e6&"
import script from "./PasswordRequest.vue?vue&type=script&lang=js&"
export * from "./PasswordRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports